import React from 'react';

export default function SelectableCard({ name, value, checked, onChange, inputMarginTop = 'mt-1', children }) {
  return (
    <label className={`flex items-start cursor-pointer p-4 border-2 rounded-lg transition-colors ${checked ? 'border-indigo-600 bg-indigo-50' : 'border-gray-200 hover:border-indigo-300'}`}>
      <input
        type="radio"
        name={name}
        value={value}
        checked={checked}
        onChange={onChange}
        className={`h-4 w-4 text-indigo-600 ${inputMarginTop}`}
      />
      <span className="ml-3 flex-1">{children}</span>
    </label>
  );
}
